module.exports = __webpack_public_path__ + "static/media/ganesh.54c1f1bf.png";